import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useMailchimpCreateSyncMutation = createMutationHook(
  CreatorIntegrationsApiClient.createMailchimpSyncJob,
  {
    mutationKey: ['createMailchimpSync'],
  },
)
